<template>
    <div class="form-group" :class="theClasses">
        <label class="form-label" v-if="!!label" for="">{{ label }} <span v-if="!!required" class="field-required-mark">*</span></label>
        <input type="password" class="form-control" :disabled="disabled" @input="updateVal($event.target.value)" :id="id" :value="value" @change="$emit('change', $event.target.value)" :placeholder="placeholder">
        <span class="field-error" v-if="!!hasError">{{ errorMessage }}</span>
    </div>
</template>
<script>
    export default {
        props: {
            value: {
                type: String
            },
            label: {
                type: String,
                default: ''
            },
            hasError: {
                type: Boolean,
                default: false
            },
            errorMessage: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'text'
            },
            id: {
                type: String,
                default: () => {
                    return 'input-' + (parseInt(Math.random()*10));
                }
            },
            placeholder: {
                type: String
            },
            required: {
                default: ''
            },
            disabled: {
                default: false
            },
            classes: {
                default: ''
            }
        },
        methods: {
            updateVal(val){
                this.$emit('input', val);
            }
        },
        computed: {
            theClasses(){
                if(typeof this.classes === 'string'){
                    const classes = {};
                    classes[this.classes] = 1;
                    return classes;
                }

                if(Array.isArray(this.classes)){
                    const classes = {};
                    this.classes.map(theClass => classes[theClass] = 1);
                    return classes;
                }

                if(this.classes && typeof this.classes === 'object' && this.classes.constructor === Object){
                    return this.classes;
                }
            }
        }
    }
</script>